var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble-maps-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{staticClass:"bubble-maps-page__widget",attrs:{"headerText":"Bubble Maps"}},[_c('bubble-map',{attrs:{"map-data":_vm.bubbleMapData}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }